module.exports = __webpack_public_path__ + "img/b_right.1d8def15.png";